import {
  SET_EMPLOYEES_TABLE_STATE,
  RESET_EMPLOYEES_TABLE_STATE,
  SET_EMPLOYEES_SELECTED_ROWS,
} from './employees.actions';

const initialState = {
  tableState: {
    pageIndex: 0,
    pageSize: 20,
    sortBy: [],
    filterRoles: [],
    viewSlug: null,
  },
  selectedRows: [],
};

export default (state: any = initialState, action: any) => {
  switch (action.type) {
    case SET_EMPLOYEES_TABLE_STATE:
      return {
        ...state,
        tableState: {
          ...state.tableState,
          ...action.payload,
          modified: true,
        },
      };
    case RESET_EMPLOYEES_TABLE_STATE:
      return {
        ...state,
        tableState: initialState.tableState,
        selectedRows: [],
      };
    case SET_EMPLOYEES_SELECTED_ROWS:
      return {
        ...state,
        selectedRows: action.payload,
      };
    default:
      return state;
  }
};
